import { render, staticRenderFns } from "./VaultFileItemWithoutPreview.vue?vue&type=template&id=413f4d1f&scoped=true&"
import script from "./VaultFileItemWithoutPreview.vue?vue&type=script&lang=ts&"
export * from "./VaultFileItemWithoutPreview.vue?vue&type=script&lang=ts&"
import style0 from "./VaultFileItemWithoutPreview.vue?vue&type=style&index=0&id=413f4d1f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413f4d1f",
  null
  
)

export default component.exports